/** First day of the accounting year containing `on` (business.accounting_start_date cycle; Jan 1 fallback).
 *  Mirrors backend core/recognition_policy.compute_accounting_year_start. Returns 'YYYY-MM-DD'. */
export const accountingYearStart = (business, on = new Date()) => {
  const raw = business?.accounting_start_date ? String(business.accounting_start_date).slice(0, 10) : '';
  const m = raw ? parseInt(raw.slice(5, 7), 10) : 1;
  const d = raw ? parseInt(raw.slice(8, 10), 10) : 1;
  const y = on.getFullYear();
  const pad = (n) => String(n).padStart(2, '0');
  const today = `${y}-${pad(on.getMonth() + 1)}-${pad(on.getDate())}`;
  const candidate = `${y}-${pad(m)}-${pad(d)}`;
  return today >= candidate ? candidate : `${y - 1}-${pad(m)}-${pad(d)}`;
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
